const SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];

function sortSizes(sizes) {
  return sizes.slice().sort((a, b) => {
    const ia = SIZE_ORDER.indexOf(a);
    const ib = SIZE_ORDER.indexOf(b);
    // Known sizes sort by order, unknown sizes go to the end alphabetically
    if (ia !== -1 && ib !== -1) return ia - ib;
    if (ia !== -1) return -1;
    if (ib !== -1) return 1;
    return a.localeCompare(b);
  });
}

/**
 * Groups products by productUrl + color so the same item in different sizes
 * appears as a single card with all sizes listed (sorted small to large).
 */
export function groupProducts(products) {
  const map = new Map();

  for (const p of products) {
    const key = `${p.productUrl}||${p.color}`;
    if (map.has(key)) {
      const existing = map.get(key);
      if (p.size && !existing.sizes.includes(p.size)) {
        existing.sizes.push(p.size);
      }
    } else {
      map.set(key, {
        ...p,
        sizes: p.size ? [p.size] : [],
      });
    }
  }

  const results = Array.from(map.values());
  for (const item of results) {
    item.sizes = sortSizes(item.sizes);
  }
  return results;
}
